import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class BadgeNotification extends Notification {
  icon() {
    return 'fas fa-award';
  }
  href() {
    const notification = this.attrs.notification;
    const content = notification.content() || {};

    // Get badge ID from notification content
    if (content.badgeId) {
      return "".concat(app.route('badges'), "?badge=").concat(content.badgeId);
    }

    // Default to badges page
    return app.route('badges');
  }
  content() {
    const notification = this.attrs.notification;
    const content = notification.content() || {};
    const badgeName = content.badgeName || app.translator.trans('fof-badges.forum.notification.a_badge');

    // Get badge colors for styling if available
    const badgeIcon = content.badgeIcon || 'fas fa-award';
    const badgeIconColor = content.badgeIconColor || '#ffffff';
    const badgeBackgroundColor = content.badgeBackgroundColor || '#667eea';
    return m("span", {
      className: "BadgeNotification-content"
    }, app.translator.trans('fof-badges.forum.notification.badge_earned', {
      badge: m("span", {
        className: "BadgeNotification-badge",
        style: {
          backgroundColor: badgeBackgroundColor,
          color: badgeIconColor
        }
      }, m("i", {
        className: badgeIcon
      }), m("span", null, badgeName))
    }));
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('fof-badges', 'forum/components/BadgeNotification', BadgeNotification);